import { apiRequest, apiEndPoints, methodType } from "./_apiConfig";

export const getAgreementsRequest = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.agreements,
    data,
    true
  );
};

export const updateAgreementStatus = async (data = {}) => {
  const endpoint = apiEndPoints.agreementStatus(data.agreementId);
  return apiRequest(
    methodType.PATCH,
    endpoint,
    data,
    true
  );
};
